import Vue from 'vue'
import alert from '../../components/alert.vue'

const alertBox = Vue.extend(alert)

alert.install = function (data) {
    let instance = new alertBox({
        data
    }).$mount()

    document.body.appendChild(instance.$el)

    Vue.nextTick(() => {
        instance.show = true
        setTimeout(() => {
            instance.show=false
            let _alert=document.getElementById('_alert')
            _alert.parentNode.removeChild(_alert);
        }, 3000);
        // show 和弹窗组件里的show对应，用于控制显隐
    })
}

export default alert